import { ISuitabilityReportData } from "@portal/types/robot/ISuitabilityReportData";
import { ISavingAgreementData } from "@portal/types/robot/ISavingAgreementData";
import { IRiskLevel } from "@portal/types/robot/IRiskLevel";
import { Language } from "@portal/types/robot/IRobotEnums";
import { ICustomerInfo } from "@portal/types/api/ICustomerInfo";

export const GetSuitabilityReport = (
  isDefaultLanguage: boolean,
  savingCalculationsRequest: ISavingAgreementData,
  riskLevelRequest: IRiskLevel,
  customerInfo?: ICustomerInfo,
) => {
  const suitabilityReportRequest = {
    customerNumber: customerInfo?.contactInfo.customerNumber,
    firstName: customerInfo?.firstname,
    lastName: customerInfo?.lastName,
    monthlyAmount: savingCalculationsRequest.monthlyAmount,
    riskLevel: savingCalculationsRequest.riskLevel,
    savingPeriod: riskLevelRequest.savingPeriod,
    sustainability: savingCalculationsRequest.sustainability,
    language: isDefaultLanguage ? Language.NB : Language.NN,
  } as ISuitabilityReportData;

  return suitabilityReportRequest;
};
